import { cn } from "@pcln/horizon";
const cruiseFormVariants = {
    default: {
        gridContainer: 'grid grid-cols-1 gap-3 @3xl:grid-cols-2 @7xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_max-content]'
    },
    compact: {
        gridContainer: [
            'grid grid-cols-1 gap-3',
            '@3xl:grid-cols-6',
            "@3xl:[grid-template-areas:'destination_destination_destination_departure_departure_departure'_'length_length_line_line_search_search']"
        ]
    }
};
const getGridContainerClass = (variant = 'full')=>{
    const v = 'compact' === variant ? 'compact' : 'default';
    return cn(cruiseFormVariants[v].gridContainer, 'mx-auto');
};
const getSubmitButtonClass = (isMobile, variant = 'full')=>{
    if (isMobile) return 'fixed bottom-4 right-4 left-4 @3xl:[grid-area:search]';
    if ('compact' === variant) return 'w-full @3xl:[grid-area:search]';
    return 'w-full @3xl:col-span-2 @7xl:col-span-1';
};
const inputClassMap = {
    destination: '@3xl:[grid-area:destination]',
    departure: '@3xl:[grid-area:departure]',
    length: '@3xl:[grid-area:length]',
    line: '@3xl:[grid-area:line]'
};
const getInputClass = (type, variant = 'full')=>{
    if ('compact' !== variant) return '';
    return inputClassMap[type];
};
export { getGridContainerClass, getInputClass, getSubmitButtonClass };
